import { useMutation, useQueryClient } from "@tanstack/react-query";

import { setFootprintingPorkPrimaryData, setFootprintingPorkPrimaryDataAdmin } from "services";

import { footprintingPorkPrimaryQueryKeys, getEnvironment, invalidateAndRefecthQueries } from "utils";

import { FOOTPRINTING_AUTOFILL_APPLIED, FOOTPRINTING_PORK_PRIMARY_DATA } from "consts";

import { FootprintingPorkPrimaryData } from "models";

export type CreatePorkPrimaryDataQueryParams = {
  autofillYear?: number;
};

export const useMutateFootprintingPorkPrimaryData = (
  farmId: string,
  year: number,
  payload: Partial<Omit<FootprintingPorkPrimaryData, "id">>,
  primaryDataId?: string
) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  const setPrimaryData = isAdmin ? setFootprintingPorkPrimaryDataAdmin : setFootprintingPorkPrimaryData;
  return useMutation(
    {
      mutationKey: [FOOTPRINTING_PORK_PRIMARY_DATA, primaryDataId, isAdmin],
      mutationFn: (qps?: CreatePorkPrimaryDataQueryParams) =>
        qps?.autofillYear ? setPrimaryData(payload, primaryDataId, qps) : setPrimaryData(payload, primaryDataId),
      onSuccess: async (_data, variables) => {
        if (variables?.autofillYear) {
          queryClient.setQueryData([FOOTPRINTING_AUTOFILL_APPLIED, "pork", farmId, year], true);
        }
        invalidateAndRefecthQueries(queryClient, [...footprintingPorkPrimaryQueryKeys(primaryDataId ?? "", farmId, year, isAdmin)]);
      },
    },
    queryClient
  );
};
